import React from "react";
import { Grid } from "@mui/material";
import LoadingSpinner from "components/LoadingSpinner";

const Loading = (props) => {
  const { width = "100%", height = "200px", loadingSize = 40 } = props;

  return (
    <Grid
      container
      justifyContent="center"
      alignItems="center"
      style={{ height, width }}
    >
      <LoadingSpinner size={loadingSize} />
    </Grid>
  );
};

export default Loading;
